<template>
  <div>
    <h1 class="page-header text-center">feedback</h1>
    <div id="feedback-para" class="center-row">
      <div class="large-12 columns">
        <div class="intro-container">
          <p class="text-center">there's no better way to improve dispensary operations and boost sales than by <br> understanding your customers, and with feedback, you'll be able to do just that by:</p>
          <div><img v-bind:src="feedbackImage" alt="feedback-img" width="50%" height="50%"></div>
          <ul>
            <li>creating customer surveys customized to your brand</li>
            <li>easily viewing your response rates, customer service, product, and net promoter scores which measure customer loyalty and tell you how likely your customers are to recommend your products to others</li>
            <li>diving deep into customer feedback reports based on type of feedback, timeframe, and customer as well as track and resolve negative feedback</li>
            <li>receiving weekly, AI-generated customer feedback reports</li>
          </ul>
          <p class="text-center">by activating now, you will be able to begin truly understanding your most valuable <br> customers and learning from their experiences, so you can keep improving.</p>
        </div>
      </div>
    </div>
    <div id="feedback-activate-program" class="row">
      <div class="large-12 columns small-centered center-button">
        <a v-if="hasAccess(userAbilitiesValue, 'FEEDBACK_CREATE')"
           class="button larger"
           id="activate-button"
           rel="noopener noreferrer"
           href="/feedback/activate">activate feedback</a>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin';
  import feedbackImage from 'feedback/feedback_featured.png';

  export default {
    name: 'InactiveView',
    mixins: [UserAbilitiesMixin],
    data() {
      return {
        feedbackImage
      }
    },
    computed: {
      ...mapGetters(
        ['userAbilitiesValue']
      ),
      ...mapState([
        'currentMerchant'
      ])
    }
  }
</script>
